module.exports = __webpack_public_path__ + "media/images/pla/pla20-36b80909265784c3868f391ab3d7e8f9.jpg";